import { render, staticRenderFns } from "./shipout-req.vue?vue&type=template&id=2666cf02&scoped=true"
import script from "./shipout-req.vue?vue&type=script&lang=js"
export * from "./shipout-req.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2666cf02",
  null
  
)

export default component.exports